import { LanguageService } from '@/services';
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(private languageService: LanguageService) {
    super();

    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.itemsPerPageLabel = this.languageService.translate('general.list.paginator.items-per-page');
    this.nextPageLabel = this.languageService.translate('general.list.paginator.next');
    this.previousPageLabel = this.languageService.translate('general.list.paginator.previous');
    this.changes.next();
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return this.languageService.translate('general.list.paginator.part-of-total', {
        PART: 0,
        WHOLE: length,
      });
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return this.languageService.translate('general.list.paginator.part-of-total', {
      PART: `${startIndex + 1} - ${endIndex}`,
      WHOLE: length,
    });
  };
}
